/* ═══════════════════════════════════════════════════════
   INNOVA 5610 · 2023 Model — section behaviour

   Progressive enhancement: the page is fully readable with
   this file blocked. Everything is queried inside the
   .iv5610v2 wrapper so a theme-editor re-render (or a
   second instance) can never cross-wire.
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function init(root) {
    if (!root || root.dataset.iv56Ready === '1') return;
    root.dataset.iv56Ready = '1';

    var $ = function (sel) { return root.querySelectorAll(sel); };
    var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

    /* ── scroll reveal ──────────────────────────────── */
    var revealables = $('.iv56-rv');

    if (!hasIO) {
      each(revealables, function (el) { el.classList.add('iv56-in'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('iv56-in');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      each(revealables, function (el) {
        // Stagger only among reveal siblings, so a lone block never waits.
        var siblings = Array.prototype.filter.call(el.parentNode.children, function (c) {
          return c.classList.contains('iv56-rv');
        });
        el.style.transitionDelay = (Math.min(siblings.indexOf(el), 4) * 70) + 'ms';
        revealObserver.observe(el);
      });
    }

    /* ── animated counter ───────────────────────────── */
    function easeOutExpo(t) { return t === 1 ? 1 : 1 - Math.pow(2, -10 * t); }

    function runCount(el) {
      var target = parseFloat(el.dataset.count);
      if (isNaN(target) || reduced) return;

      var duration = 1400;
      var start = null;
      function step(now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / duration, 1);
        el.textContent = Math.round(target * easeOutExpo(t));
        if (t < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    if (hasIO) {
      var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          runCount(entry.target);
          countObserver.unobserve(entry.target);
        });
      }, { threshold: 0.6 });
      each($('[data-count]'), function (el) { countObserver.observe(el); });
    }

    /* ── sticky buy bar ─────────────────────────────── */
    // Shown whenever the hero's buttons are off screen — above or below, so
    // phones get a buy button before they scroll down to the hero's. Hidden
    // while the offer card or closing CTA is on screen, since those already
    // carry a button and the bar would only repeat it.
    var sticky = root.querySelector('[data-iv56-sticky]');
    var heroActions = root.querySelector('.iv56-hero-actions');
    var offers = $('.iv56-buy, .iv56-final');

    if (sticky && heroActions && hasIO) {
      var heroCtaHidden = false;
      var offersInView = 0;
      var sync = function () {
        sticky.classList.toggle('iv56-on', heroCtaHidden && offersInView === 0);
      };

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { heroCtaHidden = !entry.isIntersecting; });
        sync();
      }).observe(heroActions);

      var visible = [];
      var offerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var i = visible.indexOf(entry.target);
          if (entry.isIntersecting && i === -1) visible.push(entry.target);
          if (!entry.isIntersecting && i !== -1) visible.splice(i, 1);
        });
        offersInView = visible.length;
        sync();
      }, { threshold: 0.2 });
      each(offers, function (el) { offerObserver.observe(el); });
    }

    /* ── mockup add-to-cart ─────────────────────────── */
    // Preview feedback only; the Liquid section posts a real product form.
    each($('[data-iv56-atc]'), function (btn) {
      var label = btn.innerHTML;
      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = 'Added to cart ✓';
        setTimeout(function () {
          btn.innerHTML = label;
          btn.disabled = false;
        }, 2200);
      });
    });

    /* ── offer gallery ──────────────────────────────── */
    // The strip scrolls natively; this only syncs the thumbnails with it.
    each($('[data-iv56-gallery]'), function (gallery) {
      var track = gallery.querySelector('.iv56-gallery-track');
      var slides = gallery.querySelectorAll('.iv56-gallery-track img');
      var thumbs = gallery.querySelectorAll('.iv56-thumb');
      if (!track || !slides.length) return;

      var mark = function (index) {
        each(thumbs, function (thumb, i) {
          thumb.classList.toggle('iv56-on', i === index);
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      };

      each(thumbs, function (thumb, i) {
        thumb.addEventListener('click', function () {
          var slide = slides[i];
          if (!slide) return;
          track.scrollTo({
            left: slide.offsetLeft - track.offsetLeft,
            behavior: reduced ? 'auto' : 'smooth'
          });
          mark(i);
        });
      });

      // Keep the thumbnails in step with swiping, throttled to one frame.
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          var index = Math.round(track.scrollLeft / track.clientWidth);
          mark(Math.max(0, Math.min(index, slides.length - 1)));
        });
      });
    });

    /* ── FAQ: one answer open at a time ─────────────── */
    var faqItems = $('.iv56-faq-list details');
    each(faqItems, function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        each(faqItems, function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.iv5610v2'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify's theme editor re-renders sections in place — re-init on load. */
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('.iv5610v2'), init);
  });
})();
